import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { COLOR_TYPE, THEME_COLOR, THEME_TYPE } from "@common/constant/color"
import { isSSR } from "./utils"

export function mergeClasses(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getActiveTheme(defaultTheme: keyof typeof THEME_TYPE = "LIGHT"): keyof typeof THEME_TYPE {
  if (isSSR()) return defaultTheme
  return typeof document !== "undefined" &&
    document?.documentElement?.style?.getPropertyValue("color-scheme") === THEME_TYPE.DARK
    ? "DARK"
    : "LIGHT"
}

export function getThemeColor(color: COLOR_TYPE) {
  const ACTIVE_THEME = getActiveTheme()
  return Object.values(COLOR_TYPE).includes(color)
    ? THEME_COLOR[ACTIVE_THEME][color]
    : THEME_COLOR[ACTIVE_THEME][COLOR_TYPE.PRIMARY]
}

export const getAspectRatio = (imageUrl: string) => {
  try {
    if (!imageUrl) return null

    if (typeof imageUrl !== "string") return null
    if (!imageUrl.startsWith("https://")) {
      return null
    }
    const url = new URL(imageUrl)

    const uploadRef = url.searchParams.get("_upload_ref")

    const aspectRatio = url.searchParams.get("__ar__")

    if (uploadRef !== "ic_img_tool" || !aspectRatio) return null

    return aspectRatio
  } catch (error) {
    console.warn("Invalid URL format:", error)
    return null
  }
}
